import { ref } from 'vue';
import { ActionModal, Comment } from '@/types';

// AdpDocumentCard のマーク・コメント等のモーダル表示状態をまとめる。
// 表示・非表示の状態管理のみを担い、実際のアクション（API 呼び出し）は
// useAdpDocumentActions 側が持つ。アクション成功時の閉じる処理は呼び出し側で行う。
export const useAdpDocumentModals = () => {
  const actionModal = ref<ActionModal>(undefined);
  const selectedComment = ref<Comment | undefined>(undefined);

  const showCreateCommentModal = () => {
    actionModal.value = 'comment';
  };

  const showGroupMarkModal = () => {
    actionModal.value = 'group_mark';
  };

  const showMarkModal = () => {
    actionModal.value = 'mark';
  };

  const showEditCommentModal = (comment: Comment) => {
    selectedComment.value = comment;
    actionModal.value = 'commentEdit';
  };

  const closeActionModal = () => {
    actionModal.value = undefined;
    selectedComment.value = undefined;
  };

  return {
    actionModal,
    selectedComment,
    showCreateCommentModal,
    showGroupMarkModal,
    showMarkModal,
    showEditCommentModal,
    closeActionModal,
  };
};
